/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connection_UnreachableInputs */

const en_connection_unreachable = /** @type {(inputs: Connection_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't reach TeamBlob right now.`)
};

const ar_connection_unreachable = /** @type {(inputs: Connection_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر الوصول إلى TeamBlob الآن.`)
};

/**
* | output |
* | --- |
* | "Can't reach TeamBlob right now." |
*
* @param {Connection_UnreachableInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const connection_unreachable = /** @type {((inputs?: Connection_UnreachableInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connection_UnreachableInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connection_unreachable(inputs)
	return ar_connection_unreachable(inputs)
});